import EdoSecurity from './EdoSecurity';

export default EdoSecurity;
